<template>
  <div class="w-full">
    <div v-if="loading" class="max-h-80 space-y-2 overflow-hidden p-3">
      <div v-for="item in 5" :key="item" class="h-14 animate-pulse rounded bg-gray-200"></div>
    </div>

    <div v-else id="scrollCaisseNotifications" @scroll="loadInfinite" class="max-h-80 overflow-y-auto">
      <div v-if="notifications.length === 0" class="px-4 py-8 text-center text-xs text-gray-500">
        Aucune notification
      </div>

      <button
        v-for="notification in normalizedNotifications"
        :key="notification.id"
        type="button"
        :class="notification.read_at ? 'bg-white' : 'bg-orange-50'"
        class="w-full border-b px-3 py-3 text-left hover:bg-gray-50"
        @click="openNotification(notification)"
      >
        <div class="flex gap-3">
          <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-black p-2">
            <img src="/logo/mel_logo_all_fond.png" class="h-full w-full object-contain" alt="">
          </div>
          <div class="min-w-0 flex-1">
            <p class="text-xs leading-snug text-gray-800" v-html="formatTitle(notification.data)"></p>
            <p class="mt-1 text-[0.65rem] text-gray-500">{{ notification.time[langue] || '' }}</p>
          </div>
        </div>
      </button>

      <div v-if="loadingMore" class="flex justify-center py-3">
        <div class="chaotic-orbit"></div>
      </div>

      <p v-if="finished && notifications.length > 0" class="py-3 text-center text-xs text-gray-400">
        Plus aucune notification
      </p>
    </div>
  </div>
</template>

<script>
import { clearAppBadgeAndNotifications } from '../../js/appBadge'

export default {
  props: {
    unreadCount: {
      type: Number,
      default: 0
    }
  },
  emits: ['read'],
  data() {
    return {
      notifications: [],
      loading: true,
      loadingMore: false,
      finished: false,
      page: 1,
      langue: localStorage.getItem('langue') === 'en' ? 'en' : 'fr'
    }
  },
  mounted() {
    this.loadNotifications()
  },
  methods: {
    parsedData(notification) {
      if (!notification[0]?.data) return {}
      return typeof notification[0].data === 'string' ? JSON.parse(notification[0].data) : notification[0].data
    },
    formatTitle(data) {
      const key = this.langue === 'en' ? 'titreEn' : 'titreFr'
      const title = data[key] || data.titreFr || data.titreEn || ''
      if (this.$convertTextInGras) return this.$convertTextInGras(title)
      return title.replace(/<([^<>]+)>/g, '<strong>$1</strong>')
    },
    openNotification(notification) {
      this.$router.push('/MesCommandes')
      if (this.unreadCount > 0) this.readNotifications()
    },
    readNotifications() {
      this.axios.post(this.requestHttp + 'readnotification', '', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
        },
      }).then(() => {
        this.notifications = this.notifications.map((item) => {
          if (item[0]) item[0].read_at = item[0].read_at || new Date().toISOString()
          return item
        })
        this.$store.state.notifications = this.notifications
        this.$emit('read')
        clearAppBadgeAndNotifications()
      })
    },
    loadNotifications() {
      this.axios.get(this.requestHttp + 'notifications?page=' + this.page, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
        },
      }).then(({ data }) => {
        this.notifications = data[0] || []
        this.$store.state.notifications = this.notifications
        this.page += 1
        this.loading = false
        if (this.unreadCount > 0) this.readNotifications()
      }).catch(() => {
        this.loading = false
      })
    },
    loadInfinite(e) {
      const delta = e.target.scrollHeight - (e.target.clientHeight + e.target.scrollTop)
      if (delta > 80 || this.loadingMore || this.finished) return

      this.loadingMore = true
      this.axios.get(this.requestHttp + 'notifications?page=' + this.page, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
        },
      }).then(({ data }) => {
        const next = data[0] || []
        if (next.length === 0) {
          this.finished = true
        } else {
          this.notifications.push(...next)
          this.$store.state.notifications = this.notifications
          this.page += 1
        }
        this.loadingMore = false
      }).catch(() => {
        this.loadingMore = false
      })
    }
  },
  computed: {
    normalizedNotifications() {
      return this.notifications.map((notification) => ({
        id: notification[0]?.id || JSON.stringify(notification),
        read_at: notification[0]?.read_at,
        data: this.parsedData(notification),
        time: notification[1] || {},
        raw: notification
      }))
    },
    requestHttp() {
      return this.$store.state.api
    }
  }
}
</script>
